
import { useEffect, useRef, useState, useCallback } from 'react';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

const vitassoProducts = [
  {
    id: 1,
    name: "MAG-THREEON Kids Damla",
    subtitle: "30 ML Magnezyum Damla",
    description: "Çocukların sinir sistemi ve kas gelişimi için özel formül",
    price: "710,10 ₺",
    oldPrice: "789,00 ₺",
    discount: 10,
    rating: 4.9,
    reviews: 156,
    badge: "Çok Satan",
    badgeColor: "from-amber-500 to-orange-500",
    image: "https://vitassoilac.com//storage/products/June2025/magtho kids.jpg",
    category: "Magnezyum",
    ageRange: "0-12 Yaş"
  },
  {
    id: 2,
    name: "Vita-Magne 60 Kapsül",
    subtitle: "Magnezyum Takviyesi",
    description: "Yetişkinler ve ergenler için yüksek emilimli magnezyum",
    price: "674,10 ₺",
    oldPrice: "749,00 ₺",
    discount: 10,
    rating: 5.0,
    reviews: 203,
    badge: "Premium",
    badgeColor: "from-brand-500 to-brand-700",
    image: "https://vitassoilac.com//storage/products/June2025/vitamagne.jpg",
    category: "Magnezyum",
    ageRange: "12+ Yaş"
  },
  {
    id: 3,
    name: "PRONİGHT Baby Damla",
    subtitle: "20 ML Bebek Formülü",
    description: "Bebeklerin huzurlu uyku düzeni için özel gece formülü",
    price: "585,65 ₺",
    oldPrice: "689,00 ₺",
    discount: 15,
    rating: 4.8,
    reviews: 312,
    badge: "En Çok Satan",
    badgeColor: "from-rose-500 to-pink-600",
    image: "https://vitassoilac.com//storage/products/June2025/pronight.jpg",
    category: "Bebek",
    ageRange: "0-2 Yaş"
  },
  {
    id: 4,
    name: "MAG-THREEON 60 Kapsül",
    subtitle: "Yetişkin Magnezyum",
    description: "Stres, yorgunluk ve kas kramplarına karşı güçlü destek",
    price: "854,10 ₺",
    oldPrice: "949,00 ₺",
    discount: 10,
    rating: 5.0,
    reviews: 189,
    badge: null,
    badgeColor: "",
    image: "https://vitassoilac.com//storage/products/June2025/magtho mor.jpg",
    category: "Magnezyum",
    ageRange: "Yetişkin"
  },
  {
    id: 5,
    name: "2x MAG-THREEON Kids",
    subtitle: "Kampanya Paketi",
    description: "2 adet Kids Damla + Tablet hediyeli avantajlı paket",
    price: "1.304,10 ₺",
    oldPrice: "1.449,00 ₺",
    discount: 10,
    rating: 4.9,
    reviews: 267,
    badge: "Kampanya",
    badgeColor: "from-amber-400 to-amber-600",
    image: "https://vitassoilac.com//storage/products/June2025/MagThreeOn Hediye Kampanya Kutu.jpg",
    category: "Paket",
    ageRange: "Aile"
  },
  {
    id: 6,
    name: "Antetu Bebek Parfümü",
    subtitle: "Doğal Bebek Bakım",
    description: "Hassas bebek cildi için %100 doğal içerikli parfüm",
    price: "139,30 ₺",
    oldPrice: "199,00 ₺",
    discount: 30,
    rating: 4.5,
    reviews: 94,
    badge: "Fırsat",
    badgeColor: "from-red-500 to-rose-600",
    image: "https://vitassoilac.com//storage/products/June2025/antethu.jpg",
    category: "Bakım",
    ageRange: "0-3 Yaş"
  },
  {
    id: 7,
    name: "Sitikids 50ml Damla",
    subtitle: "Sitikolin + DHA Omega 3",
    description: "Çocukların beyin gelişimi ve konsantrasyon desteği",
    price: "890,10 ₺",
    oldPrice: "989,00 ₺",
    discount: 10,
    rating: 4.5,
    reviews: 142,
    badge: "Yeni",
    badgeColor: "from-brand-400 to-cyan-500",
    image: "https://vitassoilac.com//storage/products/February2026/Sitikids-1.png",
    category: "Omega-3",
    ageRange: "2-12 Yaş"
  },
  {
    id: 8,
    name: "VitaOste",
    subtitle: "Kemik & Eklem Desteği",
    description: "Büyüme çağındaki çocuklar ve yetişkinler için kemik formülü",
    price: "1.449 ₺",
    oldPrice: null,
    discount: 0,
    rating: 4.7,
    reviews: 115,
    badge: "Yeni",
    badgeColor: "from-brand-400 to-brand-600",
    image: "https://vitassoilac.com//storage/products/June2025/vitaoste 2.jpg",
    category: "Vitamin",
    ageRange: "Tüm Aile"
  }
];

const filterTabs = [
  { id: 'all', label: 'Tüm Ürünler', icon: 'ri-apps-2-line' },
  { id: 'Magnezyum', label: 'Magnezyum', icon: 'ri-capsule-line' },
  { id: 'Bebek', label: 'Bebek', icon: 'ri-heart-pulse-line' },
  { id: 'Omega-3', label: 'Omega & DHA', icon: 'ri-drop-line' },
  { id: 'Vitamin', label: 'Vitamin', icon: 'ri-flask-line' },
  { id: 'Bakım', label: 'Bakım', icon: 'ri-leaf-line' },
];

export default function CategoryGrid() {
  const titleReveal = useScrollReveal({ animation: 'fadeUp', delay: 0 });
  const containerRef = useRef<HTMLDivElement>(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [activeFilter, setActiveFilter] = useState('all');
  const [filteredProducts, setFilteredProducts] = useState(vitassoProducts);
  const [isAnimating, setIsAnimating] = useState(false);

  // -----------------------------------------------------------------
  // Scroll progress (used for background orb animation)
  // -----------------------------------------------------------------
  useEffect(() => {
    const handleScroll = () => {
      const el = containerRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const windowH = window.innerHeight;
      const start = windowH;
      const end = -rect.height;
      const progress = Math.min(1, Math.max(0, (start - rect.top) / (start - end)));
      setScrollProgress(progress);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // -----------------------------------------------------------------
  // Filter handling – animation is kept minimal for performance
  // -----------------------------------------------------------------
  const handleFilterChange = useCallback(
    (filterId: string) => {
      if (filterId === activeFilter) return;
      setIsAnimating(true);
      setActiveFilter(filterId);

      // Small debounce to let the fade‑out animation play
      setTimeout(() => {
        if (filterId === 'all') {
          setFilteredProducts(vitassoProducts);
        } else if (filterId === 'Paket') {
          setFilteredProducts(vitassoProducts.filter(p => p.category === 'Paket'));
        } else {
          setFilteredProducts(vitassoProducts.filter(p => p.category === filterId));
        }
        // Fade‑in after products have been swapped
        setTimeout(() => setIsAnimating(false), 50);
      }, 300);
    },
    [activeFilter]
  );

  return (
    <section className="relative py-14 sm:py-20 md:py-28 overflow-hidden" ref={containerRef}>
      {/* Layered animated background */}
      <div className="absolute inset-0 bg-gradient-to-b from-white via-gray-50/80 to-white" />

      {/* Floating orbs – animated with scrollProgress */}
      <div
        className="absolute top-10 right-10 w-[300px] sm:w-[400px] md:w-[600px] h-[300px] sm:h-[400px] md:h-[600px] bg-brand-100/15 rounded-full blur-3xl"
        style={{
          transform: `translateY(${scrollProgress * -100}px) scale(${0.5 + scrollProgress * 0.6})`
        }}
      />
      <div
        className="absolute bottom-10 left-10 w-[250px] sm:w-[350px] md:w-[500px] h-[250px] sm:h-[350px] md:h-[500px] bg-amber-100/15 rounded-full blur-3xl"
        style={{
          transform: `translateY(${scrollProgress * 80}px) scale(${0.6 + scrollProgress * 0.5})`
        }}
      />

      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 relative z-10">
        {/* Section Header */}
        <div ref={titleReveal.ref} className={`text-center mb-8 sm:mb-10 md:mb-14 ${titleReveal.className}`}>
          <div className="inline-flex items-center gap-2 bg-white border border-brand-200/60 rounded-full px-4 sm:px-5 py-1.5 sm:py-2 mb-4 sm:mb-6 shadow-sm">
            <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
              <i className="ri-store-2-line text-brand-600 text-xs sm:text-sm"></i>
            </div>
            <span className="text-brand-700 text-[10px] sm:text-xs font-semibold tracking-wider uppercase">
              Vitasso Ürün Kataloğu
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-5 leading-tight">
            Aileniz İçin{' '}
            <span className="bg-gradient-to-r from-brand-600 to-brand-400 bg-clip-text text-transparent">
              Doğal Çözümler
            </span>
          </h2>
          <p className="text-gray-500 text-xs sm:text-sm max-w-2xl mx-auto leading-relaxed px-2">
            0-16 yaş arası çocuklardan yetişkinlere, tüm aile bireylerinin sağlığı için bilimsel
            formüllerle üretilmiş organik takviye ürünleri
          </p>
        </div>

        {/* Filter Tabs */}
        <FilterTabs tabs={filterTabs} activeFilter={activeFilter} onFilterChange={handleFilterChange} />

        {/* Products Grid */}
        <div
          className={`grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6 mt-6 sm:mt-8 md:mt-10 transition-opacity duration-300 ${
            isAnimating ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'
          }`}
          style={{ transition: 'opacity 0.3s ease, transform 0.3s ease' }}
        >
          {filteredProducts.map((product, index) => (
            <ProductShowcaseCard key={product.id} product={product} index={index} />
          ))}
        </div>

        {/* Stats Bar */}
        <StatsBar scrollProgress={scrollProgress} />

        {/* Bottom CTA */}
        <BottomCTA />
      </div>
    </section>
  );
}

// ---------------------------------------------------------------------
// FilterTabs component – isolated for readability and re‑usability
// ---------------------------------------------------------------------
function FilterTabs({
  tabs,
  activeFilter,
  onFilterChange,
}: {
  tabs: typeof filterTabs;
  activeFilter: string;
  onFilterChange: (id: string) => void;
}) {
  const reveal = useScrollReveal({ animation: 'fadeUp', delay: 200 });

  return (
    <div ref={reveal.ref} className={`flex justify-center ${reveal.className}`}>
      <div className="inline-flex items-center gap-1 sm:gap-1.5 bg-white rounded-xl sm:rounded-2xl p-1 sm:p-1.5 shadow-lg shadow-gray-200/50 border border-gray-100 overflow-x-auto max-w-full scrollbar-hide">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => onFilterChange(tab.id)}
            className={`flex items-center gap-1 sm:gap-2 px-2.5 sm:px-4 py-2 sm:py-2.5 rounded-lg sm:rounded-xl text-[10px] sm:text-xs font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer flex-shrink-0 ${
              activeFilter === tab.id
                ? 'bg-brand-600 text-white shadow-md shadow-brand-200'
                : 'text-gray-500 hover:text-brand-700 hover:bg-brand-50'
            }`}
          >
            <div className="w-3.5 h-3.5 sm:w-4 sm:h-4 flex items-center justify-center">
              <i className={`${tab.icon} text-xs sm:text-sm`}></i>
            </div>
            <span className="hidden xs:inline sm:inline">{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------
interface ProductType {
  id: number;
  name: string;
  subtitle: string;
  description: string;
  price: string;
  oldPrice: string | null;
  discount: number;
  rating: number;
  reviews: number;
  badge: string | null;
  badgeColor: string;
  image: string;
  category: string;
  ageRange: string;
}

// ---------------------------------------------------------------------
// Product card – includes graceful image‑load handling
// ---------------------------------------------------------------------
function ProductShowcaseCard({ product, index }: { product: ProductType; index: number }) {
  const reveal = useScrollReveal({ animation: 'zoomIn', delay: index * 80 });
  const [isHovered, setIsHovered] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(true); // stop the pulse placeholder
  };

  return (
    <div ref={reveal.ref} className={reveal.className}>
      <a
        href="#"
        className="group block relative bg-white rounded-xl sm:rounded-2xl overflow-hidden border border-gray-100 hover:border-brand-200/60 transition-all duration-500 hover:shadow-2xl hover:shadow-brand-100/40 cursor-pointer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          transform: isHovered ? 'translateY(-8px)' : 'translateY(0)',
          transition:
            'transform 0.5s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.5s ease, border-color 0.3s ease',
        }}
      >
        {/* Image Area */}
        <div className="relative w-full h-40 sm:h-52 md:h-64 overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100">
          {/* Placeholder while loading */}
          {!imageLoaded && (
            <div className="absolute inset-0 bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 animate-pulse" />
          )}

          {/* Image – show fallback if loading fails */}
          {imageError ? (
            <div className="absolute inset-0 flex items-center justify-center text-gray-400 text-sm">
              Görsel bulunamadı
            </div>
          ) : (
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-full object-contain object-center p-2 sm:p-4 transition-all duration-700 ease-out"
              style={{
                transform: isHovered ? 'scale(1.1) translateY(-4px)' : 'scale(1)',
                opacity: imageLoaded ? 1 : 0,
                transition:
                  'transform 0.7s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.3s ease',
              }}
              onLoad={() => setImageLoaded(true)}
              onError={handleImageError}
            />
          )}

          {/* Discount badge */}
          {product.discount > 0 && (
            <div className="absolute top-2 sm:top-3 left-2 sm:left-3 bg-red-500 text-white text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2.5 py-0.5 sm:py-1 rounded-md sm:rounded-lg shadow-lg shadow-red-200/50 flex items-center gap-0.5 sm:gap-1">
              <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 flex items-center justify-center">
                <i className="ri-discount-percent-line text-[8px] sm:text-[10px]"></i>
              </div>
              {product.discount}
            </div>
          )}

          {/* Custom badge */}
          {product.badge && (
            <div
              className={`absolute top-2 sm:top-3 right-2 sm:right-3 bg-gradient-to-r ${product.badgeColor} text-white text-[8px] sm:text-[10px] font-bold px-2 sm:px-3 py-0.5 sm:py-1 rounded-md sm:rounded-lg shadow-lg`}
            >
              {product.badge}
            </div>
          )}

          {/* Age range badge */}
          <div
            className="absolute bottom-2 sm:bottom-3 left-2 sm:left-3 bg-white/90 backdrop-blur-md text-gray-700 text-[8px] sm:text-[10px] font-semibold px-1.5 sm:px-2.5 py-0.5 sm:py-1 rounded-md sm:rounded-lg shadow-sm border border-gray-100/50 transition-all duration-500"
            style={{
              transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
              opacity: isHovered ? 1 : 0.8,
            }}
          >
            <div className="flex items-center gap-0.5 sm:gap-1">
              <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 flex items-center justify-center">
                <i className="ri-user-heart-line text-brand-600 text-[8px] sm:text-[10px]"></i>
              </div>
              {product.ageRange}
            </div>
          </div>

          {/* Action icons – appear on hover */}
          <div
            className="absolute bottom-2 sm:bottom-3 right-2 sm:right-3 hidden sm:flex gap-2 transition-all duration-500"
            style={{
              transform: isHovered ? 'translateY(0)' : 'translateY(12px)',
              opacity: isHovered ? 1 : 0,
            }}
          >
            <div className="w-7 h-7 sm:w-8 sm:h-8 bg-white/90 backdrop-blur-md rounded-lg flex items-center justify-center shadow-md hover:bg-brand-600 hover:text-white transition-colors cursor-pointer group/btn">
              <i className="ri-heart-line text-xs sm:text-sm text-gray-600 group-hover/btn:text-white"></i>
            </div>
            <div className="w-7 h-7 sm:w-8 sm:h-8 bg-white/90 backdrop-blur-md rounded-lg flex items-center justify-center shadow-md hover:bg-brand-600 hover:text-white transition-colors cursor-pointer group/btn">
              <i className="ri-eye-line text-xs sm:text-sm text-gray-600 group-hover/btn:text-white"></i>
            </div>
          </div>
        </div>

        {/* Content Area */}
        <div className="p-3 sm:p-4 md:p-5">
          <div className="flex items-center justify-between mb-1.5 sm:mb-2.5">
            <span className="text-brand-600 text-[8px] sm:text-[10px] font-semibold uppercase tracking-wider">
              {product.category}
            </span>
            <div className="flex items-center gap-0.5 sm:gap-1">
              <i className="ri-star-fill text-amber-400 text-[10px] sm:text-xs"></i>
              <span className="text-gray-700 text-[10px] sm:text-xs font-bold">{product.rating}</span>
              <span className="text-gray-400 text-[8px] sm:text-[10px] hidden sm:inline">
                ({product.reviews})
              </span>
            </div>
          </div>

          <h3 className="font-bold text-gray-900 text-xs sm:text-sm mb-0 sm:mb-0.5 group-hover:text-brand-700 transition-colors duration-300 line-clamp-1">
            {product.name}
          </h3>
          <p className="text-gray-400 text-[10px] sm:text-xs mb-1 sm:mb-2 hidden sm:block">{product.subtitle}</p>
          <p className="text-gray-500 text-[10px] sm:text-xs leading-relaxed mb-2 sm:mb-4 line-clamp-2 hidden md:block">
            {product.description}
          </p>

          <div className="flex items-center justify-between pt-2 sm:pt-3 border-t border-gray-100">
            <div>
              {product.oldPrice && (
                <span className="text-gray-400 text-[10px] sm:text-xs line-through block">
                  {product.oldPrice}
                </span>
              )}
              <span className="text-gray-900 font-bold text-sm sm:text-base">{product.price}</span>
            </div>
            <div
              className="w-8 h-8 sm:w-10 sm:h-10 bg-brand-600 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg shadow-brand-200/50 transition-all duration-500 hover:bg-brand-700 hover:shadow-brand-300/50 hover:scale-105 cursor-pointer"
            >
              <i className="ri-shopping-cart-2-line text-white text-sm sm:text-lg"></i>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
}

// ---------------------------------------------------------------------
// StatsBar – animates numbers once the component enters the viewport
// ---------------------------------------------------------------------
function StatsBar({ scrollProgress }: { scrollProgress: number }) {
  const reveal = useScrollReveal({ animation: 'fadeUp', delay: 400 });
  const barRef = useRef<HTMLDivElement>(null);
  const [counts, setCounts] = useState({ products: 0, families: 0, satisfaction: 0 });
  const hasAnimated = useRef(false);

  useEffect(() => {
    const el = barRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          const duration = 1800;
          const steps = 50;
          const stepTime = duration / steps;
          let step = 0;
          const interval = setInterval(() => {
            step++;
            const progress = step / steps;
            const eased = 1 - Math.pow(1 - progress, 3);
            setCounts({
              products: Math.floor(eased * 8),
              families: Math.floor(eased * 50000),
              satisfaction: Math.floor(eased * 98),
            });
            if (step >= steps) clearInterval(interval);
          }, stepTime);
        }
      },
      { threshold: 0.5 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={reveal.ref} className={`mt-10 sm:mt-12 md:mt-16 ${reveal.className}`}>
      <div
        ref={barRef}
        className="bg-gradient-to-r from-brand-800 via-brand-700 to-brand-600 rounded-2xl sm:rounded-3xl p-5 sm:p-8 md:p-10 relative overflow-hidden"
        style={{
          transform: `scale(${0.95 + Math.min(scrollProgress * 0.8, 0.05)})`,
          transition: 'transform 0.3s ease',
        }}
      >
        <div className="absolute inset-0 shimmer-bg opacity-30" />
        <div className="absolute top-0 right-0 w-32 sm:w-64 h-32 sm:h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" />

        <div className="relative z-10 grid grid-cols-3 gap-4 sm:gap-8 text-center">
          <div>
            <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-1 sm:mb-2">
              {counts.products}+ 
            </div>
            <div className="text-brand-200 text-[10px] sm:text-xs md:text-sm font-medium">Farklı Ürün</div>
            <div className="text-brand-300/60 text-[9px] sm:text-xs mt-0.5 sm:mt-1 hidden sm:block">
              Tüm aile için çözümler
            </div>
          </div>
          <div className="border-x border-white/10">
            <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-1 sm:mb-2">
              {counts.families.toLocaleString('tr-TR')}+
            </div>
            <div className="text-brand-200 text-[10px] sm:text-xs md:text-sm font-medium">Mutlu Aile</div>
            <div className="text-brand-300/60 text-[9px] sm:text-xs mt-0.5 sm:mt-1 hidden sm:block">
              Türkiye genelinde
            </div>
          </div>
          <div>
            <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-1 sm:mb-2">
              %{counts.satisfaction}
            </div>
            <div className="text-brand-200 text-[10px] sm:text-xs md:text-sm font-medium">Memnuniyet</div>
            <div className="text-brand-300/60 text-[9px] sm:text-xs mt-0.5 sm:mt-1 hidden sm:block">
              Müşteri geri bildirimi
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------
// Bottom Call‑to‑Action – includes safe external links
// ---------------------------------------------------------------------
function BottomCTA() {
  const reveal = useScrollReveal({ animation: 'fadeUp', delay: 500 });

  return (
    <div ref={reveal.ref} className={`mt-8 sm:mt-10 md:mt-12 text-center ${reveal.className}`}>
      <div className="inline-flex flex-col sm:flex-row items-center gap-4 sm:gap-6 bg-white rounded-xl sm:rounded-2xl px-5 sm:px-8 py-4 sm:py-6 shadow-xl shadow-gray-200/40 border border-gray-100 w-full sm:w-auto">
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-brand-50 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0">
            <i className="ri-customer-service-2-line text-brand-600 text-lg sm:text-xl"></i>
          </div>
          <div className="text-left">
            <div className="text-gray-900 font-bold text-xs sm:text-sm">
              Ürün danışmanlığı mı istiyorsunuz?
            </div>
            <div className="text-gray-500 text-[10px] sm:text-xs mt-0.5">
              Uzman eczacılarımız size yardımcı olsun
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 sm:gap-3 w-full sm:w-auto">
          <a
            href="https://wa.me/+905449793051"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex-1 sm:flex-none bg-emerald-600 text-white px-4 sm:px-5 py-2.5 sm:py-3 rounded-lg sm:rounded-xl font-semibold text-xs hover:bg-emerald-700 transition-all hover:shadow-lg cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-whatsapp-line text-sm"></i>
            </div>
            WhatsApp
          </a>
          <a
            href="tel:+905449793051"
            className="flex-1 sm:flex-none bg-brand-600 text-white px-4 sm:px-5 py-2.5 sm:py-3 rounded-lg sm:rounded-xl font-semibold text-xs hover:bg-brand-700 transition-all hover:shadow-lg cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-sm"></i>
            </div>
            <span className="hidden sm:inline">0 544 979 3051</span>
            <span className="sm:hidden">Ara</span>
          </a>
        </div>
      </div>
    </div>
  );
}
